
$(document).ready(function() {
    var isIphone = navigator.userAgent.indexOf("iPhone") != -1 ;
    var isIpod = navigator.userAgent.indexOf("iPod") != -1 ;
    var isIpad = navigator.userAgent.indexOf("iPad") != -1 ;

    // now set one variable for all iOS devices
    var isIos = isIphone || isIpod || isIpad ;

    /**
     * Initiate Chosen selects
     */
    var config = {
        '.chosen-select'           : {disable_search_threshold: 10, width:"100%"},
        '.chosen-select-deselect'  : {allow_single_deselect:true, width:"100%"},
        '.chosen-select-no-single' : {disable_search_threshold:100, width:"100%"},
        '.chosen-select-no-single.no-search' : {disable_search_threshold:10, width:"100%"},
        '.chosen-select-no-results': {no_results_text:'Oops, nothing found!'},
        '.chosen-select-width'     : {width:"95%"}
    };

    for (var selector in config) {
        if (config.hasOwnProperty(selector)) {
            $(selector).chosen(config[selector]);
        }

        if (isIos) {
            $(selector).each(function( index, element ){
                var placeholder = $(this).data('placeholder');
                $(this).find('option').first().html(placeholder);
            });
        }
    }
});
